module.exports = __webpack_public_path__ + "img/bg.8258a9fd.png";